import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject } from 'react';
import { REVEAL_CURTAIN_ANIMATION } from '@/components/ServicesLobbyPage/BrandEvolutionSection/const';
import { gsap } from '@/lib/gsap';
interface Params {
  sectionRef: RefObject<HTMLElement | null>;
  curtainRef: RefObject<HTMLDivElement | null>;
}
const useRevealCurtainAnimation = t0 => {
  const $ = _c(5);
  const {
    sectionRef,
    curtainRef
  } = t0;
  let t1;
  if ($[0] !== curtainRef || $[1] !== sectionRef) {
    t1 = () => {
      const section = sectionRef.current;
      const curtain = curtainRef.current;
      if (!section || !curtain) {
        return;
      }
      const {
        initialReveal,
        finalReveal,
        duration,
        ease,
        scrollTriggerStart
      } = REVEAL_CURTAIN_ANIMATION;
      gsap.set(curtain, {
        "--reveal": initialReveal
      });
      gsap.to(curtain, {
        "--reveal": finalReveal,
        duration,
        ease,
        scrollTrigger: {
          trigger: section,
          start: scrollTriggerStart,
          toggleActions: "play none none none"
        }
      });
    };
    $[0] = curtainRef;
    $[1] = sectionRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== sectionRef) {
    t2 = {
      scope: sectionRef
    };
    $[3] = sectionRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useGSAP(t1, t2);
};
export default useRevealCurtainAnimation;